import { DeductionStage, DeductionStageProps } from "../deduction/DeductionStage";
import { DeductionStatus, DeductionStatusProps } from "../deduction/DeductionStatus";
import { DeductionUser, DeductionUserProps } from "../deduction/DeductionUser";

export interface DeductionV2Props {
  id: number;
  checkNumber: string | null;
  invoiceNumber: string | null;
  invoiceDate: string | null;
  amount: number;
  stage: DeductionStageProps;
  status: DeductionStatusProps;
  analystUser: DeductionUserProps;
}

export class DeductionV2 {
  private readonly _id: number;
  private readonly _checkNumber: string | null;
  private readonly _invoiceNumber: string | null;
  private readonly _invoiceDate: string | null;
  private readonly _amount: number;
  private readonly _stage: DeductionStage;
  private readonly _status: DeductionStatus;
  private readonly _analystUser: DeductionUser;

  constructor(props: DeductionV2Props) {
    this._id = props.id;
    this._checkNumber = props.checkNumber;
    this._invoiceNumber = props.invoiceNumber;
    this._invoiceDate = props.invoiceDate;
    this._amount = props.amount;
    this._stage = new DeductionStage(props.stage);
    this._status = new DeductionStatus(props.status);
    this._analystUser = new DeductionUser(props.analystUser);
  }

  get id(): number {
    return this._id;
  }

  get checkNumber(): string | null {
    return this._checkNumber;
  }

  get invoiceNumber(): string | null {
    return this._invoiceNumber;
  }

  get invoiceDate(): string | null {
    return this._invoiceDate;
  }

  get amount(): number {
    return this._amount;
  }

  get stage(): DeductionStage {
    return this._stage;
  }

  get status(): DeductionStatus {
    return this._status;
  }

  get analystUser(): DeductionUser {
    return this._analystUser;
  }

  static from(props: DeductionV2Props): DeductionV2 {
    return new DeductionV2(props);
  }
}
